import axios from "@/utils/axios";

export async function searchTeam(search: string){
    const response = await axios.get("team/v2/search", {params: { search }})
    return response.data;
}